type Params = {
  [x: string]: string;
};

export const getSearchParams = (params: URLSearchParams) => {
  let data: Params = {};

  for (const entry of Array.from(params.entries())) {
    const [param, value] = entry;

    data = {
      ...data,
      [`${param}`]: value,
    };
  }

  return data;
};
